module.exports = __webpack_public_path__ + "components/country-flag/static/at-94da3f2cde05f71531db2e24fccb4d03.svg";